import {Component, Inject, inject, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {CommonModule, DOCUMENT} from '@angular/common';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {ConfirmDialogService} from './shared/commons/dialog/confirm-dialog/confirm-dialog.service';
import {ResourceRole, SsoUser} from './app.constants';
import {ManufacturerRest} from './service/ManufacturerRest';
import {firstValueFrom, map} from 'rxjs';
import {UserRest} from './service/UserRest';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'QRTraces';
  public router: Router = inject(Router);
  private oidcSecurityService = inject(OidcSecurityService)
  private confirmDialogService = inject(ConfirmDialogService)
  private activatedRoute = inject(ActivatedRoute);
  manufacturerRest = inject(ManufacturerRest)
  userRest = inject(UserRest)
  @Inject(DOCUMENT) private readonly document: Document
  isLoginConfirmDialogOpen = false

  ngOnInit(): void {
    this.oidcSecurityService.checkAuth().subscribe({
      next: async (e) => {
        //Should go any other place let ng oidc navigate for you
        if (e.isAuthenticated) {
          let userData = e.userData as SsoUser
          console.log(userData)
            this.userRest.updateLoginTime().subscribe()
            this.userRest.updateUserDataFromKeycloak().subscribe()
          if (userData?.resource_access?.['qrtraces']) {
            const urlParams = new URLSearchParams(window.location.search);
            const refresh_session = urlParams.get('refresh_session')
            if (refresh_session) {
              userData = await firstValueFrom(this.oidcSecurityService.forceRefreshSession().pipe(map(e=>e.userData as SsoUser)))
            }
            if (!userData?.pid) {
              this.router.navigate(['register', 'verify-thaid'])
            } else {
              this.navigateByRole(userData?.resource_access?.['qrtraces'])
            }
          } else {
            this.router.navigate(['403'])
          }
        } else {
          console.log(window.location.pathname)
          if (!window.location.pathname.startsWith("/register") && !window.location.pathname.startsWith("/p") && !window.location.pathname.startsWith("/welcome")) {
            this.router.navigate(['login'])
          }
        }
      }, error: err => {
        //https://github.com/damienbod/angular-auth-oidc-client/issues/1721
        const url = new URL(window.location.toString());
        const urlState = url.searchParams.get('state');
        if (!urlState) {
          return;
        }
        this.oidcSecurityService.getState().subscribe(oidcState => {
          if (oidcState !== urlState) {
            this.oidcSecurityService.authorize();
          }
        })
      }
    });

    this.oidcSecurityService.checkSessionChanged$.subscribe(e => {
      console.log('checkSessionChanged$', e)
      if (e && !this.isLoginConfirmDialogOpen && !this.router.url.startsWith('/p/')) {
        this.isLoginConfirmDialogOpen = true
        this.confirmDialogService.open({content: 'session หมดอายุ ต้องการล็อกอินอีกครั้งกด ยืนยัน?'}).subscribe(e => {
          if (e) {
            this.oidcSecurityService.logoff()
            this.oidcSecurityService.authorize()
          }
        })
      }
    })

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const contentEl = document.getElementById('content');
      if (contentEl) {
        contentEl.scrollTop = 0;
      }
    });
  }

  private navigateByRole(userData: ResourceRole | undefined) {
    if ("/" === window.location.pathname) {
      if (userData.roles.includes('user')) {
        this.manufacturerRest.findBySsoUserId().subscribe(e => {
          console.log("login as ", e?.businessType)
          if (!e) {
            this.router.navigate(['manufacturer'])
          } else {
            this.router.navigate(['welcome'])
          }
        })
      }
    }
    //this.router.navigate(['form'])
  }
}
